/**
 * Shared error filtering patterns and utilities for observability providers
 */

export const ignoredErrorPatterns = [
  /Failed to fetch/i,
  /Fix any of the following/i,
  /Fix all of the following/i,
  /Plugin with name/i,
  /The node before which the new node is to be inserted is not a child of this node/i,
  /duplicate key value violates unique constraint/i,
  /Login required/i,
  /USER_NOT_FOUND_DB/i,
  /load preload assets/i,
  /Unknown or invalid refresh token/i,
]
